import React from 'react';
import { useTranslation } from 'react-i18next';

const Intro: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section id="agency" className="py-20 md:py-32 bg-white">
      <div className="container mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-24 items-start">
          <div>
            {/* Studio title removed */}
            {/* Title removed as requested */}
          </div>
          <div className="flex flex-col items-start justify-between h-full pt-2">
            <div className="flex flex-wrap gap-3 mb-8">
              {/* Tags removed */}
            </div>
            {/* Discover link removed */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Intro;
